(function(angular) {
	'use strict';

	angular.module("app", [])
		.controller( 'FormController', FormController );

	FormController.$inject = [
		'$scope',
		'$http'
	];

	function FormController($scope, $http) {
        $scope.entry = {
            landing_id: "avonmore2017",
            origin: "landing",
            test_mode: 0,
            source: landing_source
        };
        $scope.terms_accepted = false;

        $scope.entry_submitted = false;

        $scope.error_message = false;
        $scope.message = "";
        $scope.working = false;

        $scope.process = function(valid) {
            if (valid && $scope.terms_accepted) {
                $scope.working = true;
                $scope.error_message = false;

                var file_inputs = angular.element('[name="file_url"], [name="file_path"], [name="file_filename"], [name="country"], [name="tellus"]');

                if ( file_inputs.length > 0 )
                {
                    file_inputs.each( function()
                    {
                        var $this = angular.element(this);
                        $scope.entry[$this.attr('name')] = $this.val();
                    });
                }

                var $promise = $http({
                    url: win_ajax_url,
                    method: "post",
                    headers: {"Content-Type": "application/x-www-form-urlencoded"},
                    data: jQuery.param({
                        action: "process_ajax_form",
                        tag: $scope.entry.landing_id,
                        formdata: $scope.entry
                    })
                });

                $promise.then(function(response) {
                        var result = response.data.result,
                            body = response.data;
                        if (result) {
                            $scope.entry_submitted = true;

                            // resize iframe
                            resizeIframe();
                        } else {
                            if (body.message) {
                                $scope.message = body.message;
                            } else {
                                $scope.message = "Submitted data is not valid. Please, verify your data and try again.";
                            }
                            $scope.error_message = true;
                        }
                    },
                    function() {
                        $scope.error_message = true;
                        $scope.message = "Something went wrong.";
                    }
                ).finally(function() {
                    $scope.working = false;
                });
            } else {
                if (! $scope.terms_accepted) {
                    $scope.message = "Please accept our terms & conditions.";
                }else {
                    $scope.message = "Invalid form data";
                }

                $scope.error_message = true;
            }
        };


        $scope.validate_checkbox = function() {
            $scope.terms_accepted = !$scope.terms_accepted;
        }
    }

})(angular);
